"use client";

export const SpaceDivision = ({ data = {} }) => {
    return (
        <>
            <div className="common__space"></div>
        </>
    );
};
